<template>
    <div></div>
</template>

<script>
  import { setarDadosDaSessao } from '../webservice/autenticar'
  import { origensAcesso } from '@/plugins/constants'
  export default {
    name: 'SetarAmbienteSSOV2',
    data: () => ({
      logo: ''
    }),
    mounted () {
      this.$session.destroy()
      const params = this.$route.query

      const ambiente = JSON.parse(atob(params.ambiente))
      const dados_usuario = JSON.parse(atob(params.dados_usuario))

      const nm_flavor = this.trazerNomeFlavor(ambiente.nm_flavor)
      ambiente.nm_flavor = nm_flavor
      this.$session.set('flavor', nm_flavor)
      this.$session.set('ambiente', ambiente)
      this.$session.set('ambiente_original', ambiente)
      this.$session.set('id_empresa', ambiente.id_empresa_newcon)
      this.$session.set('unidade_exclusiva', dados_usuario.unidade_exclusiva)
      this.$session.set('ids_empresas_permitidas', dados_usuario.ids_empresas_permitidas)
      this.$session.set('login_sso', true)
      this.$session.set('origem_acesso', dados_usuario.origemAcesso || origensAcesso.sso)
      setarDadosDaSessao(dados_usuario)

      this.$router.replace('/')
    },
    methods: {
      trazerNomeFlavor (nomeFlavor) {
        const flavorNormalizado = nomeFlavor.toLowerCase().replace(' ', '')
        // Correção temporária: mapeia consortio_pan para consorcio_pan
        return flavorNormalizado === 'consortio_pan' ? 'consorcio_pan' : flavorNormalizado
      }
    }
  }
</script>

<style scoped>
    .logo {
        width: 100%;
        margin-top: 15px;
    }

    .logo img {
        margin: auto;
        display: block;
    }
</style>
